import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-content">
        <h4>HIA Technologie Group</h4>
        <a href="tel:+33769817130">+33 7 69 81 71 30</a>
        <p>59 rue de Ponthieu, 75008 Paris</p>
        <p className="footer-copy">Conseil en systèmes et logiciels informatiques</p>
      </div>
    </footer>
  );
}

export default Footer;
